import { es } from "date-fns/locale";

/**
 * La plataforma solo se ofrece en español mexicano: fechas y números se
 * formatean siempre con este locale, sin importar el que haya guardado el
 * navegador.
 */
export const APP_LOCALE = "es-MX";

/** Locale de date-fns equivalente a APP_LOCALE. */
export const dateFnsLocale = es;
